import * as React from 'react';
import TooltipPopover from '../../Popover/popover';
import { Close } from 'rcd-cpp-ui/ui/icon/Remove';
import './reviewerCardList.scss';

type ReviewerCardListProps = {
  reviewers: any[];
  disabled?: boolean;
  isLoading?: boolean;
  onRemove?: (index: number) => void;
};

export const ReviewerCardList = ({
  reviewers,
  disabled,
  isLoading,
  onRemove
}: ReviewerCardListProps) => {
  if (!reviewers?.length) return null;
  return (
    <div className="reviewer-card-container">
      {reviewers.map((v, i) => {
        const tooltipText = v.relationship?.props?.tooltipText;
        return (
          <div className="reviewer-card" key={i}>
            <div className="reviewer-card-name">{v.props.name}</div>
            <div className="reviewer-card-right">
              {!!tooltipText && (
                <div className="reviewer-card-reason">
                  <TooltipPopover
                    type={'info'}
                    content={tooltipText}
                    packed={true}
                  />
                </div>
              )}
              {!disabled && onRemove && (
                <div
                  className={`reviewer-card-remove ${
                    isLoading ? 'disabled' : ''
                  }`}
                  onClick={() => onRemove(i)}
                >
                  <Close />
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
